<template>
  <div>
    <div class="container-fluid animatedParent " data-sequence="500">
      <div class="row animated go fadeIn " >
        <div id="carousel-example-generic" class="carousel slide slider-home carousel-fade" data-ride="carousel"
             data-interval="3000">
          <!-- Wrapper for slides -->
          <div class="carousel-inner" role="listbox">
            <div class="item active">
              <div class="overlay"></div>
             <div class="slider-box-img" style="background-image: url('/static/img/1.jpg')"></div>

            </div>
            <div class="item">
              <div class="overlay"></div>
              <div class="slider-box-img" style="background-image: url('/static/img/2.jpg')"></div>

            </div>
            <div class="item">
              <div class="overlay"></div>
              <div class="slider-box-img" style="background-image: url('/static/img/6.jpg')"></div>

            </div>
            <div class="item">
              <div class="overlay"></div>
              <div class="slider-box-img" style="background-image: url('/static/img/3.jpg')"></div>

            </div>
            <div class="item">
              <div class="overlay"></div>
              <div class="slider-box-img" style="background-image: url('/static/img/7.jpg')"></div>

            </div>
            <div class="item">
              <div class="overlay"></div>
              <div class="slider-box-img" style="background-image: url('/static/img/4.jpg')"></div>

            </div>
            <div class="item">
              <div class="overlay"></div>
              <div class="slider-box-img" style="background-image: url('/static/img/8.jpg')"></div>

            </div>
            <div class="item">
              <div class="overlay"></div>
              <div class="slider-box-img" style="background-image: url('/static/img/5.jpg')"></div>

            </div>
          </div>

          <!-- Controls -->
          <a class="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
          <header class="header">
          <div>
            <img src="/static/img/logo.png" alt="" class="logo-home">
          </div>
            <div class="lang">
              <ul>
                <li :class="checkLang('ar')"><a @click="changeLang('ar')">AR</a></li>
                <li class="between">/</li>
                <li :class="checkLang('tr')"><a @click="changeLang('tr')">TR</a></li>
                <li class="between">/</li>
                <li :class="checkLang('en')"><a @click="changeLang('en')">EN</a></li>
              </ul>
            </div>
          <input id="burger" type="checkbox" />
          <label for="burger">
            <span></span>
            <span></span>
            <span></span>
          </label>
          <nav>
            <ul class="nav navbar-nav navbar-right">
              <!--<li>-->
                <!--<select  @change="changeLang" name="lang" id="lang">-->
                  <!--<option  v-for="lang in langs" :value="lang.code" :selected="selectedLang(lang.code)">{{lang.name}}</option>-->
                <!--</select>-->
              <!--</li>-->
              <li><a href="/" v-lang.home></a></li>
              <li class="dropdown">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" v-lang.projects> <span class="caret"></span></a>
                <ul class="dropdown-menu">
                  <li><a href="/engineering" v-lang.engneeringtext></a></li>
                  <li><a href="/umbrella" v-lang.umbrellatext></a></li>
                </ul>
              </li>
                <li><a href="/blogs" v-lang.blog></a></li>
              <li><a href="/about" v-lang.about></a></li>
              <li><a href="/contact" v-lang.contactus></a></li>
            </ul>
          </nav>
        </header>
      </div>
    </div>
    <!--end header and slider -->
    <div class="content-all">
    <section class="about animatedParent " data-sequence="500">
      <div class="container animated go bounceInUp" >
        <div class="row">
          <div class="col-md-6">
            <div class="box-title">
              <a href="/engineering" ><h3 class="text-left" v-lang.engneeringtext> </h3></a>
               <a href="/engineering" ><p v-lang.engneeringdesc>
              </p></a>
            </div>
          </div>
        <div class="col-md-6">
          <a href="/engineering" ><img src="/static/img/10.jpg" alt=""></a>
        </div>
        </div>

        <div class="row">
          <div class="col-md-6 hidden-xs">
            <a href="/umbrella" ><img src="/static/img/9.jpg" alt=""></a>
          </div>
          <div class="col-md-6 hidden-xs">
            <div class="box-title">
              <a href="umbrella"><h3 class="text-left" v-lang.umbrellatext></h3></a>
             <a href="umbrella"> <p v-lang.umbrelladesc>
              </p></a>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="hidden-lg hidden-md hidden-sm col-xs-12">
            <div class="box-title">
              <a href="umbrella"><h3 class="text-left" v-lang.umbrellatext></h3></a>
              <a href="umbrella"> <p v-lang.umbrelladesc>
              </p></a>
            </div>
          </div>

          <div class="hidden-lg hidden-md hidden-sm col-xs-12">
            <a href="/umbrella" ><img src="/static/img/9.jpg" alt=""></a>
          </div>
        </div>
      </div>
    </section>
    <!--end about-->
    <section class="gallery animatedParent " data-sequence="500">
      <div class="container-fluid animated go fadeIn " >
        <div class="row">
          <div class="col-md-12 col-xs-12 col-sm-12 ">
            <div class="box-title">
              <h2 class="text-center" v-lang.latestprojects></h2>
              <p v-lang.underlatest>
              </p>
            </div>
          </div>
          <div class="container">
            <div class="row">
              <div class="box-filter">

              </div>
            </div>
          </div>
            <ul class="ul-gallery">
              <li v-for="project in projects" v-show="selected(project)" class="col-xs-12 col-sm-6 col-lg-3 col-md-4">
                <div class="box-li">
                  <a :href="/project/+project.slug">
                    <div class="box-img" :style="'background-image: url('+ project.image +')'"></div>
                    <div class="box-text">
                      <h3>{{project.title}}</h3>
                    </div>
                  </a>
                </div>
              </li>
            </ul>
        </div>
      </div>
    </section>
    <!--end gallery-->
    <section class="blog animatedParent " data-sequence="500" >
      <div class="container animated go bounceInUp" >
        <div class="row">
          <div class="col-md-12 col-xs-12 col-sm-12 ">
            <div class="box-title">
              <h2 class="text-center" v-lang.blog></h2>
            </div>
            <ul>
              <li class="col-md-4 col-xs-12 col-sm-6 "  v-for="blog in blogs">
                 <a :href="/blogs/+blog.slug"><div class="box-img" :style="'background-image: url('+ blog.image+')'"></div></a>
                <div class="box-text">
                  <h4 v-for="category in blog.category">{{category.name}}</h4>
                  <a :href="/blogs/+blog.slug"><h3>{{blog.title}}</h3></a>
                  <time><i class="fa fa-clock-o" aria-hidden="true"></i> {{blog.created_date}}</time>
                  <a :href="/blogs/+blog.slug" v-html="blog.description"></a>
                </div>
                <div class="box-link">
                  <a :href="/blogs/+blog.slug" v-lang.readmore></a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <app-footer></app-footer>
  </div>
  </div>
</template>

<script type="javascript">
import {languages,currentLang} from '../strings'
import {Urls,checkForDub} from '../config'
export default {
    mounted(){
        this.getProjects()
        this.getBlogs()
          $('.carousel').carousel();
        $('.carousel').carousel({
          interval: 1000 * 3
        });
    },
    data(){
        return{
            loading : false,
            pagination : null,
            type : 'all',
            cat : [],
            langs : languages
        }
    },
    methods:{
          selectedLang(code){
      return code === currentLang()
    },
    changeLang(lan){
           cl(window.location.href)
      this.language = lan
      redirect(window.location.href)
    },
        openGallery(images){
            var $lg = $('#dynamic');
            let gal = images
            gal.forEach(image => {
                image.src = image.img
            })
                var lg = $lg.lightGallery({
                    dynamic: true,
                    dynamicEl: gal,
                });
                lg.one("onCloseAfter.lg", function() {
                    lg.data('lightGallery').destroy(true);
                });
        },
        getProjects(){
            this.loading = true
            this.axios.get(Urls.projectsUrl+'?pages=8&language='+this.language)
                .then((response) => {
                // Success
                this.loading = false
                if(response.status === 200){
                    this.pagination = response.data.meta
                    response.data.data.forEach(project => {
                    if(! checkForDub(this.projects,project,'slug')){
                        this.$store.commit('projects/add', project)
                    }
                    })
                }
                }).catch((errors) => {
                // error
                this.loading = false
                console.log(errors)
                this.err = errors
            })
        },
        getBlogs(link){
            this.loading = true
            this.axios.get(Urls.blogsUrl+'?pages=3&language='+this.language)
                .then((response) => {
                // Success
                this.loading = false
                if(response.status === 200){
                    this.pagination = response.data.meta
                    response.data.data.forEach(blog => {
                    if(! checkForDub(this.blogs,blog,'slug')){
                        this.$store.commit('blog/add', blog)
                    }
                    })
                }
                }).catch((errors) => {
                // error
                this.loading = false
                console.log(errors)
                this.err = errors
            })
        },
        date(data){
            var blogDate = new Date(data);
            var locale = "en-us";
            return blogDate.getDay() + ' ' + blogDate.toLocaleString(locale,{ month: "short" })  + ' ' + blogDate.getFullYear();
        },
        toggle(selected){
            if(selected == 'all'){
                this.type = 'all'
            }
            if(selected === 'hide'){
                this.type = false
            }
            this.type = selected
          },
          selected(project){
            if(this.type === 'all'){
                return true
            }
            for(var i = 0; i < project.category.length; i++) {
                if(project.category[i].name === this.type) {
                    return true;
                }
            }
            return false;
        },
        checkLang(lan){
            if(this.language === lan)
              return 'active'
        }
    },
    computed:{
        projects(){
            return this.$store.state.projects.projects
        },
        blogs(){
            return this.$store.state.blog.blog
        },
        categories(){
            this.projects.forEach(project => {
                   project.category.forEach(category => {
                        if(! checkForDub(this.cat,category,'id')){
                            this.cat.push(category)
                        }
                    })
            })
            return this.cat
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/components/Home.vue